<template>
    <div class="zhuce-box">
        <div class="waikuang" v-show="!stopXia">
            <p class="tlite-text">{{$t('zhuce.reg_tilte')}}</p>
            <p class="tishi_p">{{$t('zhuce.beCareful')}}</p>
            <p class="tishi_p">{{$t('zhuce.read')}}</p>
            <el-collapse v-model="activeNames">
                <el-collapse-item class="rule" :title="$t('zhuce.fuwuGuize')" name="1">
                    <div class="xinxi-text">
                        <div class="xuhao">1</div>
                        <p class="neirong">{{ $t("zhuce.guizetext1") }}</p>
                    </div>
                    <div class="xinxi-text">
                        <div class="xuhao">2</div>
                        <p class="neirong">{{ $t("zhuce.guizetext2") }}</p>
                    </div>
                    <div class="xinxi-text">
                        <div class="xuhao">3</div>
                        <p class="neirong">{{ $t("zhuce.guizetext3") }}</p>
                    </div>
                    <div class="xinxi-text">
                        <div class="xuhao">4</div>
                        <p class="neirong">{{ $t("zhuce.guizetext4") }}</p>
                    </div>
                    <div class="xinxi-text">
                        <div class="xuhao">5</div>
                        <p class="neirong">{{ $t("zhuce.guizetext5") }}</p>
                    </div>
                    <div class="kaiGuan_el_reg">
                        <el-switch class="el-tongyi-register"
                        v-model="rule1"
                        active-color="#13ce66"
                        inactive-color="rgb(220,223,225)">
                        </el-switch>
                        <p class="neirong">{{ $t("zhuce.yes") }}</p>
                    </div>
                    
                </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="activeNames1">
                <el-collapse-item class="rule" :title="$t('zhuce.fuwu_tiaokuai')" name="1">
                    <div class="Two-rules"  @click="$router.push('/xieyi')">
                        {{ $t("zhuce.tiaokuai") }} <img src="../../assets/fenxiang (4).png" alt="">
                    </div>
                    <div class="Two-rules" style="padding-top: 0px;" @click="$router.push('/yinsi')">
                        {{ $t("zhuce.yinsi") }} <img src="../../assets/fenxiang (4).png" alt="">
                    </div>
                    <div class="kaiGuan_el_reg">
                        <el-switch class="el-tongyi-register"
                        v-model="rule2"
                        active-color="#13ce66"
                        inactive-color="rgb(220,223,225)">
                        </el-switch>
                        <p class="neirong">{{ $t("zhuce.yes") }}</p>
                    </div>
                    
                </el-collapse-item>
            </el-collapse>
            <p class="whole-gouxuan">{{ $t("zhuce.gouXuan") }}</p>
            <div class="next-step" @click="nentStop()">{{ $t("zhuce.nextStep") }}</div>
            <div class="to-login" @click="tologin()">{{ $t("zhuce.Gologin") }}</div>
        </div>
        <!-- 注册信息 -->
        <div class="waikuang2" v-show="stopXia">
            <p class="tlite-text">{{$t("zhuce.zhucetilte")}}</p>
            <div class="lei-kuang">
                <p class="input-tlite">{{$t("zhuce.useName")}}</p>
                <div class="shuru-kuang">
                    <span class="iconfont icon-yonghu"></span>
                    <input type="text" v-model="us_names" :placeholder="$t('zhuce.nameEnmle_input')"  @blur="names_blur(us_names)">
                </div>
                <p class="zihongti" v-show="ziduan.ts1">{{$t("zhuce.z_input_tishi")}}</p>
            </div>
            <div class="lei-kuang">
                <p class="input-tlite">{{$t("zhuce.mima")}}</p>
                <div class="shuru-kuang">
                    <span class="iconfont icon-mima" style="font-size: 23px; margin-left: 9px;margin-top: -5px;"></span>
                    <input type="password" v-model="name_pass_one" :placeholder="$t('zhuce.input_mima')" @blur="pass_one_blur(name_pass_one)">
                </div>
                <p class="zihongti" v-show="ziduan.ts2">{{ $t('zhuce.p_tilte_mima') }}</p>
            </div>
            <div class="lei-kuang">
                <p class="input-tlite">{{ $t('zhuce.confirm_mima') }}</p>
                <div class="shuru-kuang">
                    <span class="iconfont icon-mima" style="font-size: 23px; margin-left: 9px;margin-top: -5px"></span>
                    <input type="password"  v-model="name_pass_two" :placeholder="$t('zhuce.confirm_mima')" @blur="pass_two_blur(name_pass_two)">
                </div>
                <p class="zihongti" v-show="ziduan.ts3">{{$t("zhuce.p_tishi")}}</p>
            </div>
            <div class="lei-kuang">
                <p class="input-tlite">{{$t("zhuce.shouji")}}</p>
                <div class="shuru-kuang">
                    <span class="iconfont icon-dianhua" style="font-size: 19px;"></span>
                    <input type="text" :placeholder="$t('zhuce.shouji')" v-model="mod_cll" @blur="cells(mod_cll)">
                </div>
                <p class="zihongti" v-show="ziduan.ts4">{{$t('zhuce.p_tishi2')}}</p>
            </div>
            <div class="lei-kuang">
                <p class="input-tlite">{{$t('zhuce.yzm_tilte')}}</p>
                <div class="shuru-kuang">
                    <input type="text" v-model="yzm_fs" :placeholder="$t('zhuce.yzm_input_tishi')">
                    <div class="yzmyangshi" @click="HuoYzm()">{{text_yzm}}</div>
                </div>
                <p class="zihongti" v-show="ziduan.ts5">{{$t('zhuce.yzm_cuowu')}}</p>
            </div>
            <div class="next-step" @click="registerbottom()">{{$t('zhuce.zhuce_Button')}}</div>
            <div class="to-login" @click="nentStop()">{{$t('zhuce.PreviousStep')}}</div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default{
        data(){
            return{
                rule1:false,//服务规则1
                rule2:false,//隐私政策
                activeNames: ['1'],//手风琴 展示1
                activeNames1: ['1'],//手风琴 展示2
                stopXia:false,//注册的 下一步/上一步 false下一步，true上一步
                us_names:'',//用户名
                name_pass_one:'',//密码1
                name_pass_two:'',//密码2
                mod_cll:'',//手机号
                yzm_fs:'',//验证码
                text_yzm:'获取验证码',
                ziduan:{
                    ts1:false,
                    ts2:false,
                    ts3:false,
                    ts4:false,
                    ts5:false,
                },
                trues:{
                    te1:false,
                    te2:false,
                    te3:false,
                    te4:false,
                    te5:false,
                },
                
            }
        },
        mounted(){
        },
        methods:{
            //点击注册
            registerbottom(){
                if(this.trues.te1 == true && this.trues.te2 == true && this.trues.te3 == true && this.trues.te4 ==true){

                    let mimayw = /^[a-zA-Z0-9]{8}$/;;
                    if(mimayw.test(this.name_pass_one)){
                        // 定义请求的数据
                        const data = {
                            username:this.us_names,
                            password: this.name_pass_one,
                            phone: this.mod_cll,
                            code:this.yzm_fs
                        };
                        // //歌曲
                        axios.post('api/index/register', data)
                        .then(response => {
                            // 处理请求成功的响应
                            console.log(response.data);
                            if(response.data.msg==='注册成功'){
                                this.$router.push('/login');
                            }else if(response.data.msg === '手机号已被注册,请登录'){
                                this.$message.warning('改手机号已被注册！');
                            }
                            if(response.data.code==0){
                                this.$message.error(`${response.data.msg}`);
                            }
                        })
                        .catch(error => {
                            // 处理请求失败的错误
                            console.error(error);
                        });
                    }else{
                        this.$message.error('必须是八位字符，同时包含数字、大小写字母！');
                    }
                }else{
                    this.$message.warning('请正确填写注册信息！');
                }
                
            },
            //点击获取验证码
            HuoYzm(){
                if(this.mod_cll!==''){
                    let yz = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                    if(yz.test(this.mod_cll)){
                        let miao = 59;
                        this.text_yzm = `${miao}秒`
                        let ys = setInterval(()=>{
                            miao--;
                            this.text_yzm = `${miao}秒`
                            if(miao<=0){
                                clearInterval(ys);
                                this.text_yzm='获取验证码'
                            }
                        },1000)
                         // 定义请求的数据
                        const data = {
                            phone: this.mod_cll,
                        };
                        //歌曲
                        axios.post('api/index/node', data)
                        .then(response => {
                            // 处理请求成功的响应
                            console.log(response.data);
                        })
                        .catch(error => {
                            // 处理请求失败的错误
                            console.error(error);
                        });
                    }else{
                        this.ziduan.ts4 = true;
                    }
                }else{
                    this.$message.error('请输入手机号');
                }
            },
            //上一步和下一步
            nentStop(){
                if(this.rule1==true && this.rule2==true){
                    if(this.stopXia===false){
                        this.stopXia=true;
                    }else{
                        this.stopXia=false;
                    }
                }else{
                    this.$message.error('请同意服务器规则以及服务条款、隐私政策！');
                }
                
            },
            //去登录
            tologin(){
                this.$router.push('/login');
            },
            //用户名
            names_blur(){
                if(this.us_names!==''){
                    if(this.us_names.length >=1 && this.us_names.length<7){
                        this.ziduan.ts1 = false;
                        this.trues.te1 = true;
                    }else{
                        this.$message.error('用户名的长度最大6位！');
                    }
                }else{
                    this.ziduan.ts1 = true;
                    this.trues.te1 = false;
                }
            },
            //密码
            pass_one_blur(){
                if(this.name_pass_one!==''){
                    if(this.name_pass_one.length==8){
                        this.ziduan.ts2 = false;
                        this.trues.te2 = true;
                    }else{
                        this.$message.error('密码必须是八位数字或英文大小写！');
                    }
                }else{
                    this.ziduan.ts2 = true;
                    this.trues.te2 = false;
                }
            },
            //确认密码
            pass_two_blur(){
                if(this.name_pass_two!==''){
                    if(this.name_pass_two === this.name_pass_one){
                        this.ziduan.ts3 = false;
                        this.trues.te3 = true;
                    }else{
                        this.ziduan.ts3 = true;
                        this.trues.te3 = false;
                    }
                }
            },
            //手机号
            cells(e){
                let yz = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                if(yz.test(e)){
                    this.ziduan.ts4 = false;
                    this.trues.te4 = true;
                }else{
                    this.ziduan.ts4 = true;
                    this.trues.te4 = false;
                }
            }
        },
    }
</script>
<style lang="scss">
    .zhuce-box{
        display: flex;
        align-items: center;
        justify-content: center;
        .waikuang{
            width: 435px;
            overflow: hidden;
            display: flex;
            flex-direction:column;
            margin-top: 60px;
            margin-bottom: 60px;
            .tlite-text{
                font-size: var(--nav-text-fsize28);
                font-weight: bold;
                margin-bottom: 10px;
                color: var(--them-color);
            }
            .tishi_p{
                width: 100%;
                font-size: var(--nav-text-fsize15);
                color: var(--them-song-text-color);
                margin-top: 10px;
            }
            .rule{
                border-radius: 3px;
            }
            .whole-gouxuan{
                width: 100%;
                height: 60px;
                text-align: center;
                font-size: var(--nav-songTlite-fsize);
                color: var(--them-song-text-color);
                margin-top: 20px;
            }
            .next-step{
                height: 40px;
                border-radius: 3px;
                background-color: var(--buttom-Bf-color);
                text-align: center;
                line-height: 40px;
                margin-top: 5px;
                cursor: pointer;
                color: var(--step-text-hover-color);
                font-size: var(--nav-songTlite-fsize);
                font-family: YuanTi;
                transition: 0.2s;
            }
            .to-login{
                height: 40px;
                border-radius: 3px;
                background-color: var(--buttom-Bf-color);
                text-align: center;
                line-height: 40px;
                margin-top: 5px;
                cursor: pointer;
                font-size: var(--nav-songTlite-fsize);
                font-family: YuanTi;
                transition: 0.2s;
                margin-top: 20px;
                color:var(--step-text-hover-color);
            }
            .to-login:hover{
                background-color: var(--background-229-230-235);
                transition: 0.2s;
            }
            
        }
        .waikuang2{
            width: 435px;
            overflow: hidden;
            display: flex;
            flex-direction:column;
            margin-top: 60px;
            margin-bottom: 60px;
            .tlite-text{
                font-size: var(--nav-text-fsize28);
                font-weight: bold;
                margin-bottom: 15px;
                color: var(--them-color);
            }
            .lei-kuang{
                width: 100%;
                height: 85px;
                display: flex;
                flex-direction: column;
                margin-bottom: 6px;
                .input-tlite{
                    font-size: var(--nav-text-fsize15);
                    font-family: YuanTi;
                    margin-bottom: 5px;
                    color: var(--them-color);
                }
                .shuru-kuang {
                        width: 100%;
                        height: 36px;
                        display: flex;
                        align-items: center;
                        position: relative;
                
                        border-radius: 3px;
                
                        span{
                            width: 17px;
                            height: 17px;
                            margin-left: 12px;
                            margin-right: 12px;
                            position: absolute;
                            z-index: 10;
                            color: var( --them-color);
                        }
                
                        input {
                            width: 90%;
                            height: 100%;
                            outline: none;
                            position: absolute;
                            border: solid 1px var(--zc-input-solid);
                            background-color: var(--zc-input-background);
                            padding-left: 39px;
                            border-radius: 3px;
                            font-size: var(--nav-songTlite-fsize);
                            color: var(--them-color);
                        }
                
                        input:hover {
                            width: 90%;
                            height: 100%;
                            position: absolute;
                            background-color: var(--zc-inout-hover);
                            border: solid 1px var(--background-229-230-235);
                
                        }
                
                        input:focus {
                            background-color: var(--them-background);
                            border: solid 1px rgb(22, 94, 255);
                            border-radius: 3px;
                        }
                        .yzmyangshi{
                            position: absolute;
                            right: 0;
                            padding: 0px 15px;
                            line-height: 32px;
                            font-size: var(--nav-text-fsize);
                            color: var(--nav-song-name-color);
                            cursor: pointer;
                        }
                    }
                
                    .zihongti {
                        font-size: var(--nav-text-fsize12);
                        color: var(--tishi-color);
                        margin-top: 2px;
                    }
                }
                .next-step{
                    height: 40px;
                    border-radius: 3px;
                    background-color: var(--buttom-Bf-color);
                    text-align: center;
                    line-height: 40px;
                    margin-top: 20px;
                    cursor: pointer;
                    color: var(--step-text-hover-color);
                    font-size: var(--nav-songTlite-fsize);
                    font-family: YuanTi;
                    transition: 0.2s;
                }
                .next-step:hover{
                    background-color: var(--lan-background);
                    transition: 0.2s;
                    color: #fff;
                }
                .to-login{
                    height: 40px;
                    border-radius: 3px;
                    background-color: var(--buttom-Bf-color);
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    font-size: var(--nav-songTlite-fsize);
                    font-family: YuanTi;
                    transition: 0.2s;
                    margin-top: 20px;
                    color:var(--step-text-hover-color);
                }
                .to-login:hover{
                    background-color: var(--background-229-230-235);
                    transition: 0.2s;
                }
        }
        
    }
    .el-collapse{
        border: none !important;
        border-radius: 3px;
        margin-top: 20px;
    }
    .el-collapse-item__header{
        height: 40px !important;
        line-height: 40px !important;
        background-color: var(--input-border)!important;
        color: var(--to-zhuce-size) !important;
        cursor: pointer;
        border: 1px solid  var(--input-border)!important;
        font-size: 15px;
        padding-left: 15px;
        border-radius: 3px;
    }
    .el-collapse-item__wrap{
        border: none !important;
    }
    .el-collapse-item__header:hover{
        background-color: var(--background-229-230-235)!important;
        border: 3px;
    }
    .el-collapse-item__content{
        background-color: var(--guize-landi-backround);
        padding-bottom: 10px;
    }
    .xinxi-text{
        display: flex;
        padding-top: 10px;
        .xuhao{
            width: 32px;
            height: 32px;
            background-color: var(--guize-xuhao-background);
            border-radius: 20px;
            text-align: center;
            line-height: 32px;
            margin-left: 12px;
            margin-right: 15px;
            color: var(--guize-xuhao-text);
        }
        .neirong{
            width: 366px;
            
            font-size: var(--nav-text-fsize15);
            color: var(--them-color);
        }
    }
    .kaiGuan_el_reg{
        display: flex;
        align-items: center;
        margin-top: 15px;
        .el-tongyi-register{
            margin-left: 13px;
            margin-right: 10px;
        }
        .neirong{
            width: 366px;
            font-size: var(--nav-text-fsize15);
            color: var(--them-color);
        }
    }
    .Two-rules{
        height: 30px;
        font-size: var(--nav-text-fsize15);
        margin-left: 15px;
        padding-top: 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: var(--them-color);
        img{
            margin-left: 5px;
            width: 13px;
            height: 13px;
        }
    }
    .Two-rules:hover{
        color: var(--yinsi-to-color);
        cursor: pointer;
        span{
            color: var(--yinsi-to-color);
        }
    }
</style>